import { Bando } from "./bando.model";

export class Impresa {
    id: Number;
    ragioneSociale: String;
    bandi: Bando[];
  }
  